<template>
  <v-avatar class="booking-avatar" :class="statusColor" :size="size">
    <img v-if="photoUrl" :src="photoUrl"/>
    <v-icon v-else size="16" class="avatar-icon" :class="statusColor">icon-empty-photo</v-icon>
  </v-avatar>
</template>

<script>
  const CURRENT_STAFF = 9999;
  export default {
    name: "BookingAvatar",
    props: {
      colorId: {
        type: Number,
        required: false,
        validator: prop => prop === CURRENT_STAFF || (prop >= 0 && prop < 30)
      },
      photoUrl: {
        type: String,
        required: false,
      },
      size: {
        type: String,
        default: '18',
      }
    },
    computed: {
      statusColor() {
        return this.colorId === CURRENT_STAFF ? 'color-current-staff' : `color_${this.colorId}`;
      },
    },
  };
</script>

<style lang="scss" scoped>

  @import "../../../../../assets/scss/abstract/_variables.scss";

  .booking-avatar {

    .avatar-icon,
    img {
      border-radius: 35px;
      width: 18px;
      height: 18px;
      object-fit: cover;
    }
  }

  .color_0 {
    color: $avatar_color_0;
    background-color: rgb(255, 241, 182);
  }

  .color_1 {
    color: $avatar_color_1;
    background-color: rgb(255, 234, 182);
  }

  .color_2 {
    color: $avatar_color_2;
    background-color: rgb(255, 226, 181);
  }

  .color_3 {
    color: $avatar_color_3;
    background-color: rgb(255, 220, 180);
  }

  .color_4 {
    color: $avatar_color_4;
    background-color: rgb(254, 205, 179);
  }

  .color_5 {
    color: $avatar_color_5;
    background-color: rgb(254, 198, 183);
  }

  .color_6 {
    color: $avatar_color_6;
    background-color: rgb(250, 191, 188);
  }

  .color_7 {
    color: $avatar_color_7;
    background-color: rgb(243, 184, 175);
  }

  .color_8 {
    color: $avatar_color_8;
    background-color: rgb(240, 173, 175);
  }

  .color_9 {
    color: $avatar_color_9;
    background-color: rgb(247, 180, 202);
  }

  .color_10 {
    color: $avatar_color_10;
    background-color: rgb(234, 176, 201);
  }

  .color_11 {
    color: $avatar_color_11;
    background-color: rgb(220, 181, 227);
  }

  .color_12 {
    color: $avatar_color_12;
    background-color: rgb(202, 187, 229);
  }

  .color_13 {
    color: $avatar_color_13;
    background-color: rgb(209, 193, 254);
  }

  .color_14 {
    color: $avatar_color_14;
    background-color: rgb(188, 194, 228);
  }

  .color_15 {
    color: $avatar_color_15;
    background-color: rgb(192, 178, 255);
  }

  .color_16 {
    color: $avatar_color_16;
    background-color: rgb(182, 200, 254);
  }

  .color_17 {
    color: $avatar_color_17;
    background-color: rgb(154, 162, 210);
  }

  .color_18 {
    color: $avatar_color_18;
    background-color: rgb(174, 225, 250);
  }

  .color_19 {
    color: $avatar_color_19;
    background-color: rgb(174, 231, 239);
  }

  .color_20 {
    color: $avatar_color_20;
    background-color: rgb(173, 226, 233);
  }

  .color_21 {
    color: $avatar_color_21;
    background-color: rgb(171, 218, 213);
  }

  .color_22 {
    color: $avatar_color_22;
    background-color: rgb(174, 232, 224);
  }

  .color_23 {
    color: $avatar_color_23;
    background-color: rgb(193, 227, 195);
  }

  .color_24 {
    color: $avatar_color_24;
    background-color: rgb(186, 215, 188);
  }

  .color_25 {
    color: $avatar_color_25;
    background-color: rgb(215, 234, 194);
  }

  .color_26 {
    color: $avatar_color_26;
    background-color: rgb(159, 211, 161);
  }

  .color_27 {
    color: $avatar_color_27;
    background-color: rgb(171, 129, 152);
  }

  .color_28 {
    color: $avatar_color_28;
    background-color: rgb(131, 164, 202);
  }

  .color_29 {
    color: $avatar_color_29;
    background-color: rgb(121, 177, 255);
  }

  .color-current-staff {
    color: rgb(70, 117, 217);
    background-color: rgb(190, 207, 242);
  }

</style>
